var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { WmButton } from "@watermarkinsights/ripple-react";
import { useEffect, useReducer, useRef, useState } from "react";
import { useIntl } from "react-intl";
import { sendRequest } from "src/common/http";
import translate from "src/i18n/translate";
import "../Lightcast.scss";
import ApiError from "../../common/elements/ApiError";
import { handleChartArrowNavigation } from "../../common/helper";
var defaultPopulationByRaceResultSet = {
    currentYear: 0,
    pastYear: 0,
    populationByRace: []
};
var defaultPopulationByRaceEthnicityAction = {
    type: "",
    changeInPopulationRange: [],
    populationByRaceEthnicityChangePercentages: defaultPopulationByRaceResultSet,
    flag: false
};
var reducer = function (state, action) {
    var _a, _b, _c, _d;
    switch (action.type) {
        case "setChangeInPopulationByRaceEthnicityRange":
            return __assign(__assign({}, state), { changeInPopulationRange: action.changeInPopulationRange });
        case "setPopulationByRaceEthnicityChangePercentages":
            var changePercentages = (_a = action.populationByRaceEthnicityChangePercentages) === null || _a === void 0 ? void 0 : _a.populationByRace.map(function (population) { return population.changePercentage; });
            return __assign(__assign({}, state), { changePercentages: changePercentages });
        case "setBarsFlagByRace":
            return __assign(__assign({}, state), { setBarsByRace: action.flag });
        case "setPopulationByRaceError":
            return __assign(__assign({}, state), { pastYear: 0, currentYear: 0, populationByRaceEthnicity: [], changePercentages: [], apiError: true });
        case "setPopulationByRace":
            return __assign(__assign({}, state), { pastYear: (_b = action.populationByRaceEthnicityChangePercentages) === null || _b === void 0 ? void 0 : _b.pastYear, currentYear: (_c = action.populationByRaceEthnicityChangePercentages) === null || _c === void 0 ? void 0 : _c.currentYear, populationByRaceEthnicity: (_d = action.populationByRaceEthnicityChangePercentages) === null || _d === void 0 ? void 0 : _d.populationByRace, apiError: action.populationByRaceEthnicityChangePercentages
                    ? false
                    : true });
        default:
            return state;
    }
};
export default function PopulationByRaceEthnicity(_a) {
    var setTooglePosition = _a.setTooglePosition, onTabLoad = _a.onTabLoad, onComponentLoad = _a.onComponentLoad, showIntegratedHeader = _a.showIntegratedHeader;
    var initialState = {
        changeInPopulationRange: [],
        changePercentages: null,
        setBarsByRace: true,
        populationByRaceEthnicity: null,
        pastYear: null,
        currentYear: null,
        apiError: false
    };
    var _b = useState(false), openPopoverStateByRace = _b[0], setOpenPopoverStateByRace = _b[1];
    var _c = useState(""), selectedRowIdByRace = _c[0], setSelectedRowIdByRace = _c[1];
    var _d = useState(-1), focusedBarIndex = _d[0], setFocusedBarIndex = _d[1];
    var barRefs = useRef([]);
    var _e = useReducer(reducer, initialState), state = _e[0], dispatch = _e[1];
    var _f = useState(Number), maxTicks = _f[0], setMaxTicks = _f[1];
    var _g = useState(false), isMoveLeftBtnDisabledByRace = _g[0], setMoveLeftBtnDisable = _g[1];
    var _h = useState(false), isMoveRightBtnDisabledByRace = _h[0], setMoveRightBtnDisable = _h[1];
    useEffect(function () {
        var applyResult = function (result) {
            dispatch(__assign(__assign({}, defaultPopulationByRaceEthnicityAction), { type: "setPopulationByRace", populationByRaceEthnicityChangePercentages: result }));
            dispatch(__assign(__assign({}, defaultPopulationByRaceEthnicityAction), { type: "setPopulationByRaceEthnicityChangePercentages", populationByRaceEthnicityChangePercentages: result }));
            onTabLoad("raceEthinicity");
            onComponentLoad("populationByRace");
        };
        var onError = function () {
            dispatch(__assign(__assign({}, defaultPopulationByRaceEthnicityAction), { type: "setPopulationByRaceError" }));
            onTabLoad("raceEthinicity");
            onComponentLoad("populationByRace");
        };
        sendRequest({ uri: "/lightcast/population_by_race", camelize: true }, applyResult, onError);
    }, []);
    var timeframe = {
        pastYear: state.pastYear,
        currentYear: state.currentYear
    };
    var getChangeInPopulationRange = function (changePercentages) {
        var hasNegativeVal = changePercentages.some(function (val) { return val < 0; });
        var hasPositiveVal = changePercentages.some(function (val) { return val >= 0; });
        var absPercentageChangeValArr = absoluteValueArray(changePercentages);
        var getIntervalRangeVal = getInterval(Math.max.apply(Math, absPercentageChangeValArr), 2);
        if (hasNegativeVal && !hasPositiveVal) {
            setMaxTicks(2);
            setBarClassList("negative");
            return [
                0,
                -getIntervalRangeVal / 2,
                -getIntervalRangeVal,
                -(getIntervalRangeVal + getIntervalRangeVal / 2),
                -getIntervalRangeVal * 2
            ];
        }
        else if (hasPositiveVal && !hasNegativeVal) {
            setMaxTicks(2);
            setBarClassList("positive");
            return [
                getIntervalRangeVal * 2,
                getIntervalRangeVal + getIntervalRangeVal / 2,
                getIntervalRangeVal,
                getIntervalRangeVal / 2,
                0
            ];
        }
        else {
            setMaxTicks(2);
            return [
                getIntervalRangeVal * 2,
                getIntervalRangeVal,
                0,
                -getIntervalRangeVal,
                -getIntervalRangeVal * 2
            ];
        }
    };
    var setBarsByRace = function (changePercentages) {
        var absPercentageChangeValArr = absoluteValueArray(changePercentages);
        var ele = document.querySelectorAll(".race-barss");
        ele.forEach(getBarsHeightVal);
        function getBarsHeightVal(item, index) {
            var n = parseFloat(changePercentages[index]) * 1;
            var getHeight = function (n) {
                return ((parseFloat(changePercentages[index]) /
                    (getInterval(Math.max.apply(Math, absPercentageChangeValArr), maxTicks) *
                        maxTicks)) *
                    100);
            };
            var numbersFull = getHeight(n);
            item.style.height = Math.round(Math.abs(numbersFull)) + "%";
            if (n >= 0) {
                addClassListToElement(item, "positive");
            }
            else {
                addClassListToElement(item, "negative");
            }
        }
        if (ele && ele.length > 0)
            dispatch(__assign(__assign({}, defaultPopulationByRaceEthnicityAction), { type: "setBarsFlagByRace", flag: false }));
        return _jsx(_Fragment, {});
    };
    var openPopover = function (population, event) {
        setTooglePosition(event, "race-cohort-chart");
        setOpenPopoverStateByRace(true);
        setSelectedRowIdByRace(String(population.id));
    };
    function useClosePopoverClick(ref) {
        useEffect(function () {
            function handleClickOutside(event) {
                if (ref.current && !ref.current.contains(event.target)) {
                    setOpenPopoverStateByRace(false);
                    setFocusedBarIndex(-1);
                }
            }
            document.addEventListener("mousedown", handleClickOutside);
            return function () {
                document.removeEventListener("mousedown", handleClickOutside);
            };
        }, [ref]);
    }
    var moveLeftBtn = useIntl().formatMessage({
        id: "app.changeInPopulation.moveLeftBtn"
    });
    var moveRightBtn = useIntl().formatMessage({
        id: "app.changeInPopulation.moveRightBtn"
    });
    var chartContainerAriaLabel = useIntl().formatMessage({
        id: "app.changeInPopulation.race.chartAriaLabel"
    });
    var addBoxShadowOnBothSides = function (element) {
        element && element.classList.add("-box-shadows");
    };
    var removeBoxShadowOnBothSides = function (element) {
        element && element.classList.remove("-box-shadows");
    };
    var addBoxShadowOnLeft = function (element) {
        element && element.classList.add("-box-shadow-left");
    };
    var removeBoxShadowOnLeft = function (element) {
        element && element.classList.remove("-box-shadow-left");
    };
    var addBoxShadowOnRight = function (element) {
        element && element.classList.add("-box-shadow-right");
    };
    var removeBoxShadowOnRight = function (element) {
        element && element.classList.remove("-box-shadow-right");
    };
    var setMoveLeftRightBtnDisability = function (ref, state) {
        var element = ref === null || ref === void 0 ? void 0 : ref.current;
        if ((element === null || element === void 0 ? void 0 : element.scrollLeft) === 0) {
            setMoveLeftBtnDisable(true);
            removeBoxShadowOnLeft(element);
            removeBoxShadowOnBothSides(element);
        }
        else {
            setMoveLeftBtnDisable(false);
            addBoxShadowOnLeft(element);
            removeBoxShadowOnBothSides(element);
        }
        if ((element === null || element === void 0 ? void 0 : element.scrollLeft) !== 0 &&
            (element === null || element === void 0 ? void 0 : element.scrollLeft) < (element === null || element === void 0 ? void 0 : element.scrollWidth) - (element === null || element === void 0 ? void 0 : element.offsetWidth) - 1) {
            removeBoxShadowOnRight(element);
            removeBoxShadowOnLeft(element);
            addBoxShadowOnBothSides(element);
        }
        switch (state) {
            case "onload":
                if ((element === null || element === void 0 ? void 0 : element.scrollLeft) >
                    (element === null || element === void 0 ? void 0 : element.scrollWidth) - (element === null || element === void 0 ? void 0 : element.offsetWidth) - 1) {
                    return (setMoveRightBtnDisable(false),
                        addBoxShadowOnRight(element),
                        removeBoxShadowOnBothSides(element));
                }
                else {
                    return setMoveRightBtnDisable(false), setMoveLeftBtnDisable(true);
                }
            default:
                if ((element === null || element === void 0 ? void 0 : element.scrollLeft) >
                    (element === null || element === void 0 ? void 0 : element.scrollWidth) - (element === null || element === void 0 ? void 0 : element.offsetWidth) - 1) {
                    return setMoveRightBtnDisable(true), removeBoxShadowOnRight(element);
                }
                else {
                    return setMoveRightBtnDisable(false), addBoxShadowOnRight(element);
                }
        }
    };
    function useSetMoveLeftRightValueByRace(ref) {
        useEffect(function () {
            setTimeout(function () {
                setMoveLeftRightBtnDisability(ref, "onload");
            }, 200);
        }, [ref]);
    }
    var scrollWrapperByRace = useRef(null);
    useSetMoveLeftRightValueByRace(scrollWrapperByRace);
    useClosePopoverClick(scrollWrapperByRace);
    var setChartScrollByRace = function (element, speed, distance, direction) {
        var step = direction === "left" ? -(element === null || element === void 0 ? void 0 : element.offsetWidth) : element === null || element === void 0 ? void 0 : element.offsetWidth;
        var scrollAmount = 0;
        var slideTimer = setInterval(function () {
            element.scrollLeft += step;
            scrollAmount += Math.abs(step);
            if (scrollAmount >= distance) {
                clearInterval(slideTimer);
            }
            setMoveLeftRightBtnDisability(scrollWrapperByRace, "button-click");
        }, speed);
    };
    var getPopoverAmountData = function (population) {
        return population.changePercentage >= 0 ? "-green" : "-red";
    };
    var getNumericSignValue = function (changeInPercentageVal) {
        return changeInPercentageVal >= 0 ? "+" : "";
    };
    useEffect(function () {
        state.changePercentages &&
            dispatch(__assign(__assign({}, defaultPopulationByRaceEthnicityAction), { type: "setChangeInPopulationByRaceEthnicityRange", changeInPopulationRange: getChangeInPopulationRange(state.changePercentages) }));
    }, [state.changePercentages]);
    var handleChartContainerKeyDown = function (event) {
        var _a;
        var totalBars = ((_a = state.populationByRaceEthnicity) === null || _a === void 0 ? void 0 : _a.length) || 0;
        handleChartArrowNavigation(event, {
            totalItems: totalBars,
            currentIndex: focusedBarIndex,
            itemRefs: barRefs,
            containerRef: scrollWrapperByRace,
            onNavigate: function (newIndex) {
                setFocusedBarIndex(newIndex);
            },
            onEscape: function () {
                setOpenPopoverStateByRace(false);
                setFocusedBarIndex(-1);
            },
            onExit: function () {
                setOpenPopoverStateByRace(false);
                setFocusedBarIndex(-1);
            }
        });
    };
    return (_jsxs(_Fragment, { children: [state.changePercentages && (_jsxs("div", { className: "population-by-race-ethnicity", children: [_jsxs("div", { className: "race-cohort-chart flex-row -justified", children: [!showIntegratedHeader && (_jsx("div", { className: "header", children: _jsxs("div", { className: "info", id: "change-population-info", children: [_jsx("h3", { className: "title change-population-title", children: translate("app.changeInPopulation.ageCohort.changePopulationRaceEthnicity") }), _jsx("div", { className: "description -descrip html-desc", children: translate("app.changeInPopulation.helperText") })] }) })), !state.apiError && (_jsxs(_Fragment, { children: [showIntegratedHeader && (_jsx("div", { className: "race-cohort-label", children: translate("app.changeInPopulation.ageCohort.changePopulationRaceEthnicity") })), _jsxs("div", { className: "flex-row", children: [_jsx(WmButton, { buttonType: "icononly", tooltip: moveLeftBtn, icon: "f04d", tooltipPosition: "bottom-left", disabled: isMoveLeftBtnDisabledByRace, onClick: function () {
                                                    return setChartScrollByRace(scrollWrapperByRace.current, 25, 100, "left");
                                                }, tabIndex: -1 }), _jsx(WmButton, { buttonType: "icononly", tooltip: moveRightBtn, icon: "f054", tooltipPosition: "bottom-left", disabled: isMoveRightBtnDisabledByRace, onClick: function () {
                                                    return setChartScrollByRace(scrollWrapperByRace.current, 25, 100, "right");
                                                }, tabIndex: -1 })] })] }))] }), !state.apiError && (_jsxs("div", { className: "flex-row -verticallycentered", children: [_jsx("div", { className: "percentage-change-label", children: translate("app.changeInPopulation.ageCohort.percentageChange") }), _jsx("div", { className: "race-cohort-chart", id: "race-cohort-chart-container", tabIndex: 0, role: "application", "aria-labelledby": "age-cohort-header", ref: scrollWrapperByRace, "aria-description": chartContainerAriaLabel, onKeyDown: handleChartContainerKeyDown, children: _jsx("div", { className: "race-bar-chart", id: "race-bar-chart", children: _jsxs("div", { className: "race-row bars", children: [_jsx("div", { className: "y-axis one", children: state.changeInPopulationRange.map(function (populChange) {
                                                    return (_jsx("div", { className: "race-segment", children: _jsx("span", { className: "race-label", children: populChange }) }, populChange));
                                                }) }), _jsx("div", { className: "race-x-axis", id: "race-x-axis", children: state.populationByRaceEthnicity &&
                                                    state.populationByRaceEthnicity.map(function (population, index) {
                                                        var changeState = population.changePercentage >= 0
                                                            ? translate("app.trends.increased")
                                                            : translate("app.trends.decreased");
                                                        return (_jsxs("div", { className: "year wrap", children: [_jsx("div", { className: "race-col", children: _jsx("div", { className: "race-barss tooltip", onFocus: function (event) {
                                                                            return openPopover(population, event);
                                                                        }, ref: function (el) { return (barRefs.current[index] = el); }, tabIndex: -1, children: _jsx("div", { className: "population-tooltiptext tooltiptext-years ".concat(openPopoverStateByRace &&
                                                                                String(population.id) ===
                                                                                    selectedRowIdByRace
                                                                                ? "-visible"
                                                                                : "-hidden"), children: _jsxs("div", { className: "race-tooltip-text", children: [_jsx("div", { className: "population-popover-amount \n                              ".concat(getPopoverAmountData(population)), children: getNumericSignValue(population.changePercentage) +
                                                                                            population.changePercentage +
                                                                                            "%" }), _jsx("div", { className: "population-popover-text", children: translate("app.changeInPopulation.race.popoverLabelText", {
                                                                                            raceName: population.race,
                                                                                            changeState: changeState,
                                                                                            changePercentage: Math.abs(population.changePercentage),
                                                                                            pastYear: timeframe.pastYear,
                                                                                            currentYear: timeframe.currentYear
                                                                                        }) })] }) }) }) }), _jsx("span", { className: "race-label", children: population.race })] }, population.id));
                                                    }) })] }) }) })] })), state.setBarsByRace ? setBarsByRace(state.changePercentages) : "", !state.apiError && (_jsx("div", { className: "pop-race-year", children: translate("app.changeInPopulation.race.raceEthnicityLabel") }))] })), state.apiError && _jsx(ApiError, {})] }));
}
var addClassListToElement = function (item, classesToAdd) {
    item.classList.add(classesToAdd);
};
var getElementListAndSetClassList = function (elementTofetch, classToAdd) {
    var element = document.querySelectorAll(elementTofetch);
    element.forEach(setClassList);
    function setClassList(item, index) {
        addClassListToElement(item, classToAdd);
    }
};
var getNegativeValBarView = function () {
    getElementListAndSetClassList(".race-col", "col-height");
    var barElement = document.querySelectorAll(".race-barss");
    barElement.forEach(removeBarClassList);
    function removeBarClassList(item, index) {
        item.classList.remove("negative");
    }
    getElementListAndSetClassList(".race-label", "-label-tranform");
    getElementListAndSetClassList(".race-x-axis", "-transform");
    getElementListAndSetClassList(".race-segment", "-border-top");
    getElementListAndSetClassList(".race-tooltip-text", "-transform-tooltip");
    getElementListAndSetClassList(".race-cohort-chart", "-negative-space");
};
var getPostiveValBarView = function () {
    getElementListAndSetClassList(".race-col", "col-height");
    var barElement = document.querySelectorAll(".race-barss");
    barElement.forEach(removeBarClassList);
    function removeBarClassList(item) {
        item.classList.remove("negative");
    }
};
var setBarClassList = function (valStatus) {
    switch (valStatus) {
        case "negative":
            return getNegativeValBarView();
        default:
            return getPostiveValBarView();
    }
};
var absoluteValueArray = function (percentages) {
    return percentages.map(Math.abs);
};
var getInterval = function (largest, ticks) {
    var minimum = largest / ticks;
    var magnitude = Math.pow(10, Math.floor(Math.log10(minimum)));
    var residual = minimum / magnitude;
    var interval;
    if (residual > 5) {
        interval = 10 * magnitude;
    }
    else if (residual > 3) {
        interval = 5 * magnitude;
    }
    else if (residual > 2) {
        interval = 3 * magnitude;
    }
    else if (residual > 1.5) {
        interval = 2 * magnitude;
    }
    else if (residual > 1) {
        interval = 1.5 * magnitude;
    }
    else {
        interval = magnitude;
    }
    return interval;
};
